import React from "react";

const ExploreUndefined = () => {
    return (
        <div className="discoverInstructions-container">
            <p>Due to a terrible miscommunication, the ship was energized before selecting a proper target.</p>
            <p>The ship and crew have been lost in space.</p>
        </div>
    )
}

export default ExploreUndefined;